// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application
import { environment } from './../environments/environment';
import { PortalConfig } from './shared/models';
const {
  version,
  debugInfoEnabled,
  ngpBackendURL,
  defaultPortal,
  portalURL,
  chartAlertServerURL,
  chartPortal,
  analyticsDataAPIServerURL,
  sessionIdleTime,
  showLoginSection,
  sessionTimeoutTime,
  userMicroServiceURL_LPL,
  userMicroServiceURL_SECURE,
  bffURL,
  bffURLVersion,
  authMiddlewareURL
} = environment;
export const VERSION = version;
export const DEBUG_INFO_ENABLED: boolean = debugInfoEnabled;
export const SERVER_API_URL = `${ngpBackendURL}/`;
export const CHART_FIRM_SERVER_URL = portalURL;
export const DEFAULT_PORTAL = defaultPortal;
export const CHART_NGP_SERVER_URL = ngpBackendURL;
export const CHART_ALERT_SERVER_URL = chartAlertServerURL;
export const CHART_PORTAL = chartPortal;
export const BUILD_TIMESTAMP = new Date().getTime();
export const SHOW_LOGIN_SECTION = showLoginSection;
export const SESSION_IDLE_TIME = sessionIdleTime;
export const SESSION_TIMEOUT_TIME = sessionTimeoutTime;
export const ANALYTICS_DATA_API_SERVER_URL = analyticsDataAPIServerURL;
export const USER_SERVICE_SERVER_URL_LPL = userMicroServiceURL_LPL;
export const USER_SERVICE_SERVER_URL_SECURE = userMicroServiceURL_SECURE;
export const BFF_BASE_URL = `${bffURL}/api/${bffURLVersion}`;
export const AUTH_MIDDLEWARE_LOGIN_URL = `${authMiddlewareURL}/api/${bffURLVersion}/users/login`;
export const AUTH_MIDDLEWARE_URL = `${authMiddlewareURL}/api/${bffURLVersion}/auth`;
export const BFF_URL = bffURL;

export enum CLIENT {
  LPL = 'lpl',
  IFG = 'ifg',
  BERTHEL = 'berthel',
  ADVISOR_GROUP = 'ag',
  UNIFY = 'unify',
  BDSECURITY = 'bdsecurity',
  SECURE = 'secure',
  PRO_EQUITIES = 'proequities',
  ENTERPRISE = 'enterprise'
}

export const PORTAL_CONFIG: Record<CLIENT, PortalConfig> = {
  [CLIENT.ADVISOR_GROUP]: {
    portalLogin: true,
    ngpLogin: true,
    cognitoUrl: ''
  },
  [CLIENT.LPL]: {
    portalLogin: true,
    ngpLogin: true,
    cognitoUrl: ''
  },
  [CLIENT.SECURE]: {
    portalLogin: true,
    ngpLogin: true,
    cognitoUrl: ''
  },
  [CLIENT.UNIFY]: {
    portalLogin: false,
    ngpLogin: true,
    cognitoUrl: ''
  },
  [CLIENT.IFG]: {
    portalLogin: false,
    ngpLogin: true,
    cognitoUrl:
      'https://us-west-2h6fshupsz.auth.us-west-2.amazoncognito.com/login?client_id=13gsepj8jel9sudpq8nmo2rled&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https%3A%2F%2Fngpstaging.entreda.com%3FportalName%3Difg'
  },
  [CLIENT.BERTHEL]: {
    portalLogin: false,
    ngpLogin: true,
    cognitoUrl:
      'https://us-west-2nxs3frv5q.auth.us-west-2.amazoncognito.com/login?client_id=5485pgplgci3bquqifu2u028e6&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone&redirect_uri=https%3A%2F%2Fngpstaging.entreda.com%3FportalName%3Dberthel'
  },

  [CLIENT.BDSECURITY]: {
    portalLogin: false,
    ngpLogin: true,
    cognitoUrl:
      'https://us-west-2asxjomfif.auth.us-west-2.amazoncognito.com/login?client_id=2k8bp75r6t88g14a8d057d3no7&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone&redirect_uri=https%3A%2F%2Fngpstaging.entreda.com%3FportalName%3Dbdsecurity'
  },
  [CLIENT.PRO_EQUITIES]: {
    portalLogin: false,
    ngpLogin: true,
    cognitoUrl:
      'https://us-west-2zmlmx1o9w.auth.us-west-2.amazoncognito.com/login?client_id=13hthpelmoj8uc5013e181q103&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone&redirect_uri=https%3A%2F%2Fngpstaging.entreda.com%3FportalName%3Dproequities'
  },
  [CLIENT.ENTERPRISE]: {
    portalLogin: false,
    ngpLogin: true,
    cognitoUrl:
      'https://us-west-2wezsaueir.auth.us-west-2.amazoncognito.com/login?client_id=4imgr2aumfgfjfc47rpci1nh5t&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone&redirect_uri=https%3A%2F%2Fngpstaging.entreda.com%3FportalName%3Denterprise'
  }
};
